import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { SubscriptionService } from '@prlw/core/customers/subscription/subscription.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'prlw-check-active-subscriptions',
  imports: [],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckActiveSubscriptionsContainer implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  constructor(private readonly subscriptionService: SubscriptionService) {
    subscriptionService.checkSubscriptions$
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }
}
